// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"211":"3b451e39","684":"3b451e39","980":"3b451e39"}[chunkId] + ".chunk.css";
};